import {Decoder, field, nullable, number, object, string} from 'json-bouncer'
import {LocalDateTime} from 'js-joda'
import {localDateTimeDecoder} from '../Data/DecodeHelper'

export interface InquiryPosition {
    readonly id: number
    readonly inquiryId: number
    readonly userId: number
    readonly name: string
    readonly totalNetPrice: number | null
    readonly totalGrossPrice: number | null
    readonly weight: number
    readonly amount: number
    readonly productShippingServiceId: number
    readonly productCalculationId: number | null
    readonly notes: string | null
    readonly productId: number | null
    readonly deleted: LocalDateTime | null
}

export function decoder(): Decoder<InquiryPosition> {
    return object({
        id: field('id', number()),
        inquiryId: field('inquiryId', number()),
        userId: field('userId', number()),
        name: field('name', string()),
        totalNetPrice: field('totalNetPrice', nullable(number())),
        // Todo: Überlegen ob Punkt Komma Problem hier schon angegangen werden soll!
        totalGrossPrice: field('totalGrossPrice', nullable(number())),
        weight: field('weight', number()),
        amount: field('amount', number()),
        productShippingServiceId: field('productShippingServiceId', number()),
        productCalculationId: field('productCalculationId', nullable(number())),
        notes: field('notes', nullable(string())),
        productId: field('productId', nullable(number())),
        deleted: field('deleted', nullable(localDateTimeDecoder())),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryPosition.ts